import React, { useEffect } from "react";
import Header from "./header";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { useThemesContext } from "../context/ThemeProvider";
import { ChangesHistoryProvider } from "../screens/visual/context";
import EditorContainer from "./editor-container";

const EditorWrapper = () => {

    const { themeId } = useParams();
    const shopId = useSelector(({ auth }) => auth?.shop?.id);
    const {
        getThemeById,
        getMenus,
        getPages,
        getProductList,
        getFeedbackList,
        getTicketList,
        resetMenuState,
        setSelectedTemplate,
        selectedTheme
    } = useThemesContext();

    useEffect(() => {
        if(shopId) {
            resetMenuState();
            setSelectedTemplate(null);
            getThemeById(themeId);
            getMenus();
            getPages();
            getProductList();
            getFeedbackList();
            getTicketList();
        }
    }, [shopId, themeId]);

    if(!shopId || !selectedTheme) {
        return null
    }

    return (
        <ChangesHistoryProvider currentTheme={selectedTheme}>
            <Header />
            <EditorContainer />
        </ChangesHistoryProvider>
    )
}

export default EditorWrapper